import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NewsList from "../../common/NewsList";
import SummaryCardLayout from "./SummaryCardLayout";
import { getHomeDataAPI } from "../../../apis/news_service";
import { getMyDataAPI } from "../../../apis/my_service";
import Loading from "../../../pages/error/Loading";
import more from "../../../assets/images/ico_more.svg";

const FinanceNewsLayout = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [orderType, setOrderType] = useState("NEWS"); // 긍정뉴스 조회기준 NEWS or CHANGE
  const [orderType_n, setOrderType_n] = useState("NEWS"); // 부정뉴스 조회기준 NEWS or CHANGE
  const [tSummarymsg, setTSummarymsg] = useState(""); // 오늘의 큐레이팅
  const [mSummarymsg, setMSummarymsg] = useState(""); // 3개월 통계 큐레이팅
  const [newsList, setNewsList] = useState([]); // 뉴스 리스트
  const [stockList, setStockList] = useState([]); // 종목 리스트
  const [tSummarymsg_n, setTSummarymsg_n] = useState(""); // 오늘의 큐레이팅
  const [mSummarymsg_n, setMSummarymsg_n] = useState(""); // 3개월 통계 큐레이팅
  const [newsList_n, setNewsList_n] = useState([]); // 뉴스 리스트
  const [stockList_n, setStockList_n] = useState([]); // 종목 리스트

  // const moveToNews = (id, name, signal) => {navigate(`/news/${id}`, {state: {stockname: name, signal: signal}})}
  const moveToNews = (type, signal, title, range) => {
    navigate(`/news/${type}/${signal === "긍정" ? "positive" : "negative"}`, {
      state: { type: type, title: title, range: range },
    });
  };

  const financeHomeData = () => {
    getHomeDataAPI("stocks", "1", orderType).then((res) => {
      setTSummarymsg(res.tSummarymsg);
      setMSummarymsg(res.mSummarymsg);
      setNewsList(res.newslist);
      setStockList(res.stocklist);
      setLoading(false);
    });
    getHomeDataAPI("stocks", "2", orderType_n).then((res) => {
      setTSummarymsg_n(res.tSummarymsg);
      setMSummarymsg_n(res.mSummarymsg);
      setNewsList_n(res.newslist);
      setStockList_n(res.stocklist);
      setLoading(false);
    });
  };

  const financeMyData = () => {
    getMyDataAPI("stocks", "1", orderType).then((res) => {
      setTSummarymsg(res.tSummarymsg);
      setMSummarymsg(res.mSummarymsg);
      setNewsList(res.newslist);
      setStockList(res.stocklist);
      setLoading(false);
    });
    getMyDataAPI("stocks", "2", orderType_n).then((res) => {
      setTSummarymsg_n(res.tSummarymsg);
      setMSummarymsg_n(res.mSummarymsg);
      setNewsList_n(res.newslist);
      setStockList_n(res.stocklist);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (window.location.pathname.includes("mycorp")) {
      financeMyData();
    } else {
      financeHomeData();
    }
  }, [orderType, orderType_n]);

  return (
    <>
      <div className="finance inner_container">
        <div className="divider">
          <span className="title_lg">금융시장 뉴스</span>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="main_layout divider">
              <div className="positive_area">
                <div className="flex_layout">
                  <p>
                    <span
                      onClick={() => setOrderType("NEWS")}
                      className={`${orderType === "NEWS" ? "on" : ""}`}
                    >
                      긍정 뉴스가 많은 기업 순
                    </span>
                    <span className="separator">·</span>
                    <span
                      onClick={() => setOrderType("CHANGE")}
                      className={`${orderType === "NEWS" ? "" : "on"}`}
                    >
                      상승률 높은 기업 순
                    </span>
                  </p>
                  <div className="click">
                    <span
                      className="click"
                      onClick={() =>
                        moveToNews("finance", "긍정", "양의기업", null)
                      }
                    >
                      뉴스 더보기
                    </span>
                    <img src={more} alt="more" />
                  </div>
                </div>
                <div className="curate_area flex_layout">
                  <div className="curate_box">
                    <p className="curate_msg">{tSummarymsg}</p>
                  </div>
                  <div className="curate_box">
                    <p className="curate_msg">{mSummarymsg}</p>
                  </div>
                </div>
                <NewsList
                  newsList={newsList}
                  type="vertical"
                  size="3"
                  main="main"
                />
              </div>

              <div className="negative_area">
                <div className="flex_layout">
                  <p>
                    <span
                      onClick={() => setOrderType_n("NEWS")}
                      className={`${orderType_n === "NEWS" ? "on" : ""}`}
                    >
                      부정 뉴스가 많은 기업 순
                    </span>
                    <span className="separator">·</span>
                    <span
                      onClick={() => setOrderType_n("CHANGE")}
                      className={`${orderType_n === "CHANGE" ? "on" : ""}`}
                    >
                      하락률 높은 기업 순
                    </span>
                  </p>
                  <div className="click">
                    <span
                      className="click"
                      onClick={() =>
                        moveToNews("finance", "부정", "음의기업", null)
                      }
                    >
                      뉴스 더보기
                    </span>
                    <img src={more} alt="more" />
                  </div>
                </div>
                <div className="curate_area flex_layout">
                  <div className="curate_box">
                    <p className="curate_msg">{tSummarymsg_n}</p>
                  </div>
                  <div className="curate_box">
                    <p className="curate_msg">{mSummarymsg_n}</p>
                  </div>
                </div>
                <div className="newslist_container">
                  <NewsList
                    newsList={newsList_n}
                    type="vertical"
                    size="3"
                    main="main"
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {loading === false && (
        <SummaryCardLayout
          stockList={stockList}
          stockList_n={stockList_n}
          bg="#fff"
          padding="30px 0 25px 0"
          type="기업"
        />
      )}
    </>
  );
};

export default FinanceNewsLayout;
